export default "__VITE_ASSET__BvakvFqL__"